<form [formGroup]="editProfileBioForm" (ngSubmit)="onSubmitEditProfileNameForm()" class="wrapper-edit-info-page">
  <span class="title-edit-page">{{'NEW_TEXT.bio' | translate}}</span>
  <span class="subtitle-edit-page">{{'NEW_TEXT.change_your_account_bio' | translate}}</span>
  <div class="wrapper-input textarea" [ngClass]="{'error': editProfileBioForm.controls['bio'] | formControlErrorMessages: null : formTriedToSubmit}">
    <span class="label-input">{{'NEW_TEXT.bio' | translate}}</span>
    <div class="custom-input">
      <textarea formControlName="bio" [maxLength]="150"></textarea>
    </div>
    <div *ngIf="editProfileBioForm.controls['bio'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
      <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
      <span>{{editProfileBioForm.controls['bio'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
    </div>
    <span class="label-info-input" *ngIf="!(editProfileBioForm.controls['bio'] | formControlErrorMessages: null: formTriedToSubmit)">{{editProfileBioForm.controls['bio'].value ? (150 - editProfileBioForm.controls['bio'].value.length) + ' characters left.' : 'The maximum length of a bio is 150 characters.'}}</span>
  </div>
  <div class="buttons-edit-page">
    <button type="button" (click)="onCancelChanges()" class="custom-btn custom-btn--outline">
      <span>{{'NEW_TEXT.cancel' | translate}}</span>
    </button>
    <button type="submit" class="custom-btn custom-btn--primary">
      <span *ngIf="!isSpinnerActive">{{'NEW_TEXT.save_changes' | translate}}</span>
      <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
    </button>
  </div>
</form>
